import { MapDealTypes } from '@shared/config/mapDealTypes';
export const getDefaultMapDealsType = ({ salesTotal, rentsTotal }) => {
    if (rentsTotal > 0 && salesTotal === 0) {
        return MapDealTypes.Rent;
    }
    return MapDealTypes.Sale;
};
